import { Form } from 'formik';
import { useRef } from 'react';
import { TEACHER_ETHNICITY_OPTIONS, TEACHER_RACE_OPTIONS } from '@myap/metadata';
import { ChooseRaceEthnicity } from './fields';
import * as c from './constants';
import styles from '../../../sass/registration.module.scss';
export default (function (props) {
  var initialValues = props.initialValues,
    values = props.values,
    setFieldValue = props.setFieldValue,
    dirty = props.dirty,
    isValid = props.isValid,
    isSubmitting = props.isSubmitting,
    errors = props.errors,
    client = props.client,
    isLoading = props.isLoading,
    status = props.status,
    setStatus = props.setStatus,
    _props$educationPerio = props.educationPeriodData,
    selectedEducationPeriod = _props$educationPerio.selectedEducationPeriod,
    availableEducationPeriods = _props$educationPerio.availableEducationPeriods,
    _props$educationPerio2 = _props$educationPerio.selectedIsCurrent,
    selectedIsCurrent = _props$educationPerio2 === void 0 ? true : _props$educationPerio2,
    isModal = props.isModal,
    mutationErrors = props.mutationErrors,
    queryErrors = props.queryErrors;
  var disableForm = isLoading || isSubmitting;
  var submitRef = useRef(null);
  return /*#__PURE__*/React.createElement(Form, {
    className: styles.registration
  }, /*#__PURE__*/React.createElement(ChooseRaceEthnicity, {
    values: values,
    initialValues: initialValues,
    disabled: disableForm,
    isSubmitting: isSubmitting,
    client: client,
    setFieldValue: setFieldValue,
    isCurrentYear: selectedIsCurrent,
    ethnicityOptions: TEACHER_ETHNICITY_OPTIONS,
    raceOptions: TEACHER_RACE_OPTIONS,
    requiredValues: c.REQUIRED_TEACHER_VALUES,
    requiresPrivacyCheck: false,
    isLoading: isLoading
  }), /*#__PURE__*/React.createElement("div", {
    className: "".concat(styles['locked-save-button'])
  }, /*#__PURE__*/React.createElement("p", null, "Before clicking \"Save,\" confirm that all information entered on this page is accurate."), status === 'error' ? /*#__PURE__*/React.createElement("p", {
    className: "cb-error-msg",
    role: "alert"
  }, "There was an error saving your information. Please try again later.") : null, /*#__PURE__*/React.createElement("button", {
    type: "submit",
    className: "btn btn-sm btn-primary",
    disabled: !isValid || disableForm,
    ref: submitRef
  }, isSubmitting ? 'Saving...' : 'Save'), (mutationErrors || queryErrors) && isModal ? /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: "btn btn-sm btn-secondary",
    "data-dismiss": "modal",
    style: {
      marginLeft: '100px'
    }
  }, "Close") : null));
});